import { Dispatch, SetStateAction } from 'react';
import { TextFieldProps } from '@mui/material';

import { IconOption } from '@components/base';
import { SearchContext } from '@enums/SearchContext';

export const groupedSearchContexts: Partial<Record<IconOption, SearchContext[]>> = {
  search: [SearchContext.TITLE, SearchContext.PROVIDER_TITLE_ID],
  lookup: [SearchContext.MASTER_ID, SearchContext.PLATFORM_TITLE_ID],
};

export type ElementFocus = { button: boolean; input: boolean; menu: boolean };

export type GlobalSearchTextFieldProps = TextFieldProps & {
  hasFocus: boolean;
  queryText: string;
  searchContext: SearchContext;
  setElementFocus: (element: keyof ElementFocus, focused: boolean) => void;
  setQueryText: Dispatch<SetStateAction<string>>;
  setSearchContext: Dispatch<SetStateAction<SearchContext>>;
};
